/* CUSTOM-START: PROD-009 | Flexible Silicon accessory picker | 2026-07-29 */
if (!customElements.get('accessory-picker')) {
  customElements.define(
    'accessory-picker',
    class AccessoryPicker extends HTMLElement {
      connectedCallback() {
        if (this.isConnectedToPicker) return;

        this.form = this.querySelector('.accessory-picker__form');
        this.submitButton = this.querySelector('.accessory-picker__submit');
        this.buyNowButton = this.querySelector('[data-buy-now]');
        this.howToOrderLink = this.querySelector('[data-how-to-order-link]');
        this.message = this.querySelector('.accessory-picker__message');
        this.productInfo = this.closest('product-info');
        this.cartDrawer = document.querySelector('cart-drawer');

        this.onChangeHandler = this.onChange.bind(this);
        this.onSubmitHandler = this.onSubmit.bind(this);
        this.onBuyNowHandler = this.onBuyNow.bind(this);
        this.onHowToOrderLinkClickHandler = this.onHowToOrderLinkClick.bind(this);
        this.onProfileQuantityInputHandler = this.onProfileQuantityInput.bind(this);
        this.onNativeQuantityInputHandler = this.onNativeQuantityInput.bind(this);

        if (!this.form || !this.submitButton || !this.productInfo) return;

        this.addEventListener('change', this.onChangeHandler);
        this.form.addEventListener('submit', this.onSubmitHandler);

        if (this.buyNowButton) {
          this.buyNowButton.addEventListener('click', this.onBuyNowHandler);
        }
        if (this.howToOrderLink) {
          this.howToOrderLink.addEventListener('click', this.onHowToOrderLinkClickHandler);
        }

        this.profileQuantityInput = this.querySelector('[data-profile-quantity]');
        this.nativeQuantityInput = this.productInfo.querySelector('.product-form .quantity__input[name="quantity"]');

        if (this.profileQuantityInput && this.nativeQuantityInput) {
          if (this.nativeQuantityInput.value) {
            this.profileQuantityInput.value = this.nativeQuantityInput.value;
          }

          this.profileQuantityInput.addEventListener('input', this.onProfileQuantityInputHandler);
          this.profileQuantityInput.addEventListener('change', this.onProfileQuantityInputHandler);
          this.nativeQuantityInput.addEventListener('input', this.onNativeQuantityInputHandler);
          this.nativeQuantityInput.addEventListener('change', this.onNativeQuantityInputHandler);
        }

        this.isConnectedToPicker = true;
      }

      disconnectedCallback() {
        if (!this.isConnectedToPicker) return;

        this.removeEventListener('change', this.onChangeHandler);
        if (this.form) {
          this.form.removeEventListener('submit', this.onSubmitHandler);
        }
        if (this.buyNowButton) {
          this.buyNowButton.removeEventListener('click', this.onBuyNowHandler);
        }
        if (this.howToOrderLink) {
          this.howToOrderLink.removeEventListener('click', this.onHowToOrderLinkClickHandler);
        }
        if (this.profileQuantityInput) {
          this.profileQuantityInput.removeEventListener('input', this.onProfileQuantityInputHandler);
          this.profileQuantityInput.removeEventListener('change', this.onProfileQuantityInputHandler);
        }
        if (this.nativeQuantityInput) {
          this.nativeQuantityInput.removeEventListener('input', this.onNativeQuantityInputHandler);
          this.nativeQuantityInput.removeEventListener('change', this.onNativeQuantityInputHandler);
        }

        this.isConnectedToPicker = false;
      }

      onHowToOrderLinkClick(event) {
        event.preventDefault();
        const tabButton = document.querySelector(
          '[id$="52bf00c5-c1a5-4bcd-9b87-204e690ab1d5-c60d101c-a2c3-440d-ba37-38021fffba13"][role="tab"]'
        );
        if (tabButton) {
          tabButton.click();
        }
        setTimeout(() => {
          const guideSection = document.getElementById('fitting-accessories-guide');
          if (guideSection) {
            guideSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 50);
      }

      onProfileQuantityInput(event) {
        if (this._syncingQuantity || !this.nativeQuantityInput) return;
        this._syncingQuantity = true;
        this.nativeQuantityInput.value = event.target.value;
        this.nativeQuantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        this.nativeQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        this.clearMessage();
        this._syncingQuantity = false;
      }

      onNativeQuantityInput(event) {
        if (this._syncingQuantity || !this.profileQuantityInput) return;
        this._syncingQuantity = true;
        this.profileQuantityInput.value = event.target.value;
        this._syncingQuantity = false;
      }

      onChange(event) {
        if (!event.target.matches('[data-accessory-checkbox]')) return;

        const row = event.target.closest('[data-accessory-row]');
        const quantityInput = row?.querySelector('[data-accessory-quantity]');
        row?.classList.toggle('is-selected', event.target.checked);
        if (quantityInput) quantityInput.disabled = !event.target.checked;
        this.clearMessage();
      }

      async addAccessoriesToCart() {
        const profileItem = this.getProfileItem();
        const items = this.getCartItems(profileItem);
        const sections = this.getSectionsToRender();
        const cartAddUrl = `${window.routes?.cart_add_url || '/cart/add'}`.replace(/\.js$/, '') + '.js';

        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items,
            sections,
            sections_url: window.location.pathname
          })
        });
        const state = await response.json();

        if (!response.ok || state.status) {
          throw new Error(state.description || state.message || 'These items could not be added. Please try again.');
        }

        return { state, profileItem };
      }

      async onSubmit(event) {
        event.preventDefault();
        if (this.submitButton?.getAttribute('aria-disabled') === 'true') return;

        try {
          this.clearMessage();
          this.setLoading(true, this.submitButton);

          if (this.cartDrawer?.setActiveElement) {
            this.cartDrawer.setActiveElement(this.submitButton);
          }

          const { state, profileItem } = await this.addAccessoriesToCart();

          if (this.cartDrawer?.renderContents && state.sections) {
            this.cartDrawer.renderContents(state);
          } else {
            this.refreshCartBubble(state.sections?.['cart-icon-bubble']);
          }

          document.dispatchEvent(
            new CustomEvent('afterCartChanged', {
              detail: {
                productVariantId: profileItem.id,
                source: 'accessory-picker',
                cartData: state
              }
            })
          );
          this.showMessage('Profile and selected accessories added to your cart.', 'success');
        } catch (error) {
          console.error(error);
          this.showMessage(error.message || 'These items could not be added. Please try again.', 'error');
        } finally {
          this.setLoading(false);
        }
      }

      async onBuyNow(event) {
        event.preventDefault();
        if (this.buyNowButton?.getAttribute('aria-disabled') === 'true') return;

        try {
          this.clearMessage();
          this.setLoading(true, this.buyNowButton);

          await this.addAccessoriesToCart();

          window.location.href = '/checkout';
        } catch (error) {
          console.error(error);
          this.showMessage(error.message || 'These items could not be added. Please try again.', 'error');
          this.setLoading(false);
        }
      }

      getProfileItem() {
        const variantInput = this.productInfo.querySelector('.product-form .product-variant-id');
        const quantityInput = this.productInfo.querySelector('.product-form .quantity__input[name="quantity"]');
        const id = Number.parseInt(variantInput?.value, 10);

        if (!id || variantInput.disabled) {
          throw new Error('Please choose an available profile option first.');
        }

        return {
          id,
          quantity: this.getValidQuantity(quantityInput?.value)
        };
      }

      getCartItems(profileItem) {
        const quantitiesByVariant = new Map([[profileItem.id, profileItem.quantity]]);

        this.querySelectorAll('[data-accessory-row]').forEach((row) => {
          const checkbox = row.querySelector('[data-accessory-checkbox]');
          if (!checkbox?.checked) return;

          const id = Number.parseInt(row.dataset.variantId, 10);
          const quantity = this.getValidQuantity(row.querySelector('[data-accessory-quantity]')?.value);
          if (!id) return;

          quantitiesByVariant.set(id, (quantitiesByVariant.get(id) || 0) + quantity);
        });

        return Array.from(quantitiesByVariant, ([id, quantity]) => ({ id, quantity }));
      }

      getValidQuantity(value) {
        const quantity = Number.parseInt(value, 10);
        return Number.isInteger(quantity) && quantity > 0 ? quantity : 1;
      }

      getSectionsToRender() {
        const drawerSections = this.cartDrawer?.getSectionsToRender?.().map((section) => section.id) || [];
        return [...new Set([...drawerSections, 'cart-icon-bubble'])];
      }

      refreshCartBubble(sectionHtml) {
        const cartBubble = document.getElementById('cart-icon-bubble');
        if (!cartBubble || !sectionHtml) return;

        const section = new DOMParser().parseFromString(sectionHtml, 'text/html').querySelector('.shopify-section');
        if (section) cartBubble.innerHTML = section.innerHTML;
      }

      setLoading(isLoading, activeButton = null) {
        const buttons = [this.submitButton, this.buyNowButton].filter(Boolean);
        buttons.forEach((btn) => {
          btn.toggleAttribute('disabled', isLoading);
          btn.setAttribute('aria-disabled', String(isLoading));
          const isThisActive = isLoading && btn === activeButton;
          btn.classList.toggle('loading', isThisActive);
          const spinner = btn.querySelector('.loading-overlay__spinner');
          if (spinner) {
            spinner.classList.toggle('hidden', !isThisActive);
          }
        });
      }

      showMessage(text, type) {
        this.message.textContent = text;
        this.message.classList.toggle('accessory-picker__message--success', type === 'success');
        this.message.classList.toggle('accessory-picker__message--error', type === 'error');
        this.message.hidden = false;
      }

      clearMessage() {
        this.message.textContent = '';
        this.message.hidden = true;
        this.message.classList.remove('accessory-picker__message--success', 'accessory-picker__message--error');
      }
    }
  );
}
/* CUSTOM-END: PROD-009 */
